// Placeholder for device types
export enum DeviceType {
  DESKTOP = 'DESKTOP',
  MOBILE_TOUCH = 'MOBILE_TOUCH',
  MOBILE_KEYPAD = 'MOBILE_KEYPAD',
  TABLET = 'TABLET'
}

export interface DeviceCapabilities {
  type: DeviceType
  hasPhysicalKeypad: boolean
  hasHardwareScanner: boolean
  screenWidth: number
  screenHeight: number
  isGloveOperable: boolean
  thumbZoneHeight: number
}
